import WorkerSelectModal from "../../shared/WorkerSelectModal";
import { ConfirmModal } from "../../../../components/ui";
import DayDetails from "../../shared/DayDetails";
import BroadcastModal from "./BroadcastModal";
import DispatchModal from "./DispatchModal";
import ReviewModal from "./ReviewModal";
import useDispatchDayDetailsActions from "./useDispatchDayDetailsActions";

/**
 * Dispatch adapter for the shared planning DayDetails card.
 *
 * This component owns Dispatch-specific actions, modals, and mutations, then
 * passes resolved worker groups, DayDetails, menu options, and weather into the
 * shared display component.
 *
 * @param {Object} props
 * @param {Object} props.workerAssignments Worker assignment summary for this date.
 * @param {Array<Object>} props.availableWorkers Full Dispatch worker catalog.
 * @param {number} props.index Date index in the current Dispatch week.
 * @param {Date} props.date Calendar date represented by this summary.
 * @returns {JSX.Element|null}
 */
const DispatchDayDetails = ({ workerAssignments, availableWorkers, index, date }) => {
  const actions = useDispatchDayDetailsActions({
    workerAssignments,
    availableWorkers,
    index,
    date,
  });

  if (!actions.shouldRender) {
    return null;
  }

  return (
    <>
      <DayDetails
        type="dispatch"
        date={date}
        dayDetails={actions.dayDetails}
        weather={actions.weather}
        assignedWorkers={actions.assignedWorkers}
        offWorkWorkers={actions.offWorkWorkers}
        availableWorkers={actions.availableWorkers}
        menuItems={actions.menuItems}
        disabledMenuItems={actions.disabledMenuItems}
        menuAlign={actions.menuAlign}
        title={actions.title}
        onOffWorkClick={actions.openWorkerModal}
        offWorkDisabled={actions.offWorkDisabled}
        offWorkTitle={actions.offWorkTitle}
        isLastDay={actions.isLastDay}
        className={actions.cardClassName}
      />
      <WorkerSelectModal {...actions.workerModal} />
      <DispatchModal {...actions.dispatchModal} />
      <BroadcastModal {...actions.broadcastModal} />
      <ReviewModal {...actions.reviewModal} />
      <ConfirmModal {...actions.deleteModal} />
      <ConfirmModal {...actions.pasteModal} />
      <ConfirmModal {...actions.clearWorkersModal} />
    </>
  );
};

export default DispatchDayDetails;
